import GlobalModalManager from './GlobalModalManager';

export default GlobalModalManager;
